// Object used to track JS scripts that have been initialized
window.jsLoaded = {};

function getFocusableElements(container) {
    return Array.from(
        container.querySelectorAll(
            "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
    );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
    summary.setAttribute('role', 'button');
    summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

    if (summary.nextElementSibling.getAttribute('id')) {
        summary.setAttribute('aria-controls', summary.nextElementSibling.id);
    }

    summary.addEventListener('click', (event) => {
        event.currentTarget.setAttribute(
            'aria-expanded',
            !event.currentTarget.closest('details').hasAttribute('open')
        );
    });

    if (summary.closest('header-drawer')) return;
    summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
    var elements = getFocusableElements(container);
    var first = elements[0];
    var last = elements[elements.length - 1];

    removeTrapFocus();

    trapFocusHandlers.focusin = (event) => {
        if (event.target !== container && event.target !== last && event.target !== first) return;

        document.addEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.focusout = function () {
        document.removeEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.keydown = function (event) {
        if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
        // On the last focusable element and tab forward, focus the first element.
        if (event.target === last && !event.shiftKey) {
            event.preventDefault();
            first.focus();
        }

        //  On the first focusable element and tab backward, focus the last element.
        if ((event.target === container || event.target === first) && event.shiftKey) {
            event.preventDefault();
            last.focus();
        }
    };

    document.addEventListener('focusout', trapFocusHandlers.focusout);
    document.addEventListener('focusin', trapFocusHandlers.focusin);

    elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
    document.querySelector(':focus-visible');
} catch (e) {
    focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
    const navKeys = [
        'ARROWUP',
        'ARROWDOWN',
        'ARROWLEFT',
        'ARROWRIGHT',
        'TAB',
        'ENTER',
        'SPACE',
        'ESCAPE',
        'HOME',
        'END',
        'PAGEUP',
        'PAGEDOWN',
    ];
    let currentFocusedElement = null;
    let mouseClick = null;

    window.addEventListener('keydown', (event) => {
        if (navKeys.includes(event.code.toUpperCase())) {
            mouseClick = false;
        }
    });

    window.addEventListener('mousedown', (event) => {
        mouseClick = true;
    });

    window.addEventListener(
        'focus',
        () => {
            if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

            if (mouseClick) return;

            currentFocusedElement = document.activeElement;
            currentFocusedElement.classList.add('focused');
        },
        true
    );
}

function pauseAllMedia() {
    document.querySelectorAll('.js-youtube').forEach((video) => {
        video.contentWindow.postMessage(
            '{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
            '*'
        );
    });
    document.querySelectorAll('.js-vimeo').forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', '*');
    });
    document.querySelectorAll('video').forEach((video) => video.pause());
    document.querySelectorAll('product-model').forEach((model) => {
        if (model.modelViewerUI) model.modelViewerUI.pause();
    });
}

function removeTrapFocus(elementToFocus = null) {
    document.removeEventListener('focusin', trapFocusHandlers.focusin);
    document.removeEventListener('focusout', trapFocusHandlers.focusout);
    document.removeEventListener('keydown', trapFocusHandlers.keydown);

    if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    const summaryElement = openDetailsElement.querySelector('summary');
    openDetailsElement.removeAttribute('open');
    summaryElement.setAttribute('aria-expanded', false);
    summaryElement.focus();
}

class QuantityInput extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input');
        this.changeEvent = new Event('change', { bubbles: true });

        this.querySelectorAll('button').forEach((button) =>
            button.addEventListener('click', this.onButtonClick.bind(this))
        );
    }

    onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;

        event.target.name === 'plus' || event.target.firstElementChild.parentNode.parentNode.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
    let t;
    return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
    };
}

function fetchConfig(type = 'json') {
    return {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
    };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
    window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
    return function () {
        return fn.apply(scope, arguments);
    };
};

Shopify.setSelectorByValue = function (selector, value) {
    for (var i = 0, count = selector.options.length; i < count; i++) {
        var option = selector.options[i];
        if (value == option.value || value == option.innerHTML) {
            selector.selectedIndex = i;
            return i;
        }
    }
};

Shopify.addListener = function (target, eventName, callback) {
    target.addEventListener
        ? target.addEventListener(eventName, callback, false)
        : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
    options = options || {};
    var method = options['method'] || 'post';
    var params = options['parameters'] || {};

    var form = document.createElement('form');
    form.setAttribute('method', method);
    form.setAttribute('action', path);

    for (var key in params) {
        var hiddenField = document.createElement('input');
        hiddenField.setAttribute('type', 'hidden');
        hiddenField.setAttribute('name', key);
        hiddenField.setAttribute('value', params[key]);
        form.appendChild(hiddenField);
    }
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
    this.countryEl = document.getElementById(country_domid);
    this.provinceEl = document.getElementById(province_domid);
    this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

    Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

    this.initCountry();
    this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
    initCountry: function () {
        var value = this.countryEl.getAttribute('data-default');
        Shopify.setSelectorByValue(this.countryEl, value);
        this.countryHandler();
    },

    initProvince: function () {
        var value = this.provinceEl.getAttribute('data-default');
        if (value && this.provinceEl.options.length > 0) {
            Shopify.setSelectorByValue(this.provinceEl, value);
        }
    },

    countryHandler: function (e) {
        var opt = this.countryEl.options[this.countryEl.selectedIndex];
        var raw = opt.getAttribute('data-provinces');
        var provinces = JSON.parse(raw);

        this.clearOptions(this.provinceEl);
        if (provinces && provinces.length == 0) {
            this.provinceContainer.style.display = 'none';
        } else {
            for (var i = 0; i < provinces.length; i++) {
                var opt = document.createElement('option');
                opt.value = provinces[i][0];
                opt.innerHTML = provinces[i][1];
                this.provinceEl.appendChild(opt);
            }

            this.provinceContainer.style.display = '';
        }
    },

    clearOptions: function (selector) {
        while (selector.firstChild) {
            selector.removeChild(selector.firstChild);
        }
    },

    setOptions: function (selector, values) {
        for (var i = 0, count = values.length; i < values.length; i++) {
            var opt = document.createElement('option');
            opt.value = values[i];
            opt.innerHTML = values[i];
            selector.appendChild(opt);
        }
    },
};

Shopify.emitCartUpdateEvent = function (responseAsJson) {
    document.dispatchEvent(
        new CustomEvent('cartUpdate', {
            detail: {
                cart: responseAsJson,
            },
        })
    );
};

Shopify.addToCart = async function (variants, options = {}) {
    const { eventData = {}, open = false, emitUpdateEvent = true } = options;
    const cartDrawer = document.querySelector('cart-drawer');

    if (typeof variants === 'string') {
        variants = [{ id: variants }];
    }

    const variantsWithUniqueProperties = variants.map((variant, index) => {
        if (!variant.properties || !variant.properties._unique_id) {
            return {
                ...variant,
                properties: {
                    ...(variant.properties || {}),
                    _unique_id: `${Date.now()}-${index}-${Math.random().toString(36).substring(2, 9)}`
                }
            };
        }

    return variant;
    });

    const response = await fetch(Shopify.routes.root + 'cart/add.js', {
        ...fetchConfig(),
        body: JSON.stringify({
            items: variantsWithUniqueProperties,
            sections: cartDrawer?.getSectionsToRender().map((section) => section.id) || [],
            sections_url: window.location.pathname,
        }),
    });

    if (response.status) {
    }

    const data = await response.json();
    if (emitUpdateEvent) {
        Shopify.emitCartUpdateEvent(data);
    }

    if (cartDrawer) {
        cartDrawer.refreshCart();
        if (open) {
            cartDrawer.open();
            cartDrawer.setActiveElement(document.activeElement);
        }
    }

    return data;
};

Shopify.getCart = async function () {
    const response = await fetch(Shopify.routes.root + 'cart.js');
    const data = await response.json();
    return data;
};

/**
 * Can change `quantity`, `properties`, and `selling_plan` of a cart line item
 * Only items already in the cart can be changed
 */
Shopify.updateLineItems = async function (lineItem, { updateCart, emitUpdateEvent = true } = {}) {
    const response = await fetch(Shopify.routes.root + 'cart/change.js', {
        ...fetchConfig(),
        body: JSON.stringify({ ...lineItem }),
    });
    const data = await response.json();
    if (emitUpdateEvent) {
        Shopify.emitCartUpdateEvent(data);
    }
    if (updateCart) {
        const cartDrawer = document.querySelector('cart-drawer');
        cartDrawer.refreshCart();
    }
    return data;
};

Shopify.renderSection = async function ({
    url = window.location.pathname,
    section_id = null,
    selector,
    returnRawResponse = false,
}) {
    if (!section_id) throw new Error("Missing 'section_id' parameter");

    const urlObject = new URL(url, window.location.origin);
    urlObject.searchParams.append('sections', section_id);

    const response = await fetch(urlObject.href);
    const data = await response.json();
    if (returnRawResponse) {
        return data;
    }
    const html = data[section_id];
    if (selector) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const element = doc.querySelector(selector);
        return element;
    } else {
        return html;
    }
};

Shopify.updateCart = async function (lineItems) {
    const response = await fetch(Shopify.routes.root + 'cart/update.js', {
        ...fetchConfig(),
        body: JSON.stringify({ updates: lineItems }),
    });
    const data = await response.json();
    Shopify.emitCartUpdateEvent(data);
    return data;
};

Shopify.removeItems = async function (lineItems) {
    const updates = lineItems.reduce((acc, curr) => {
        acc[curr] = 0;
        return acc;
    }, {});

    return Shopify.updateCart(updates);
};

class BundlesManagerClass {
    constructor() {
        subscribe(PUB_SUB_EVENTS.bundleCancelled, this.onBundleCancelled.bind(this));
    }

    onBundleCancelled() {
        window.localStorage.removeItem(STORAGE_KEYS.bundle);
    }

    static async upgradeBundle() {
        const bundle = BundlesManagerClass.getBundle();
        if (bundle) {
            const type = bundle.productsInBundle[0].type;
            if (type === 'orthotic') {
                const upgradeVariantId = bundle.productsInBundle[0].bundleVariantId;
                const bundleId = bundle.bundleId;
                const cart = await Shopify.getCart();
                const nonBundledOrthotic = cart.items.find((lineItem) => {
                    return (
                        lineItem.properties['_bundleId'] === bundleId &&
                        lineItem.product_type === 'orthotic'
                    );
                });

                if (nonBundledOrthotic) {
                    await Shopify.removeItems([nonBundledOrthotic.key]);
                    await Shopify.addToCart([
                        {
                            ...nonBundledOrthotic,
                            id: upgradeVariantId,
                        },
                    ]);
                }
            }
        }
    }

    static async demoteBundle(bundleId, nonBundledVariantId) {
        if (!nonBundledVariantId || !bundleId) return false;
        const cart = await Shopify.getCart();
        const bundledOrthotic = cart.items.find((lineItem) => {
            return (
                lineItem.properties['_bundleId'] === bundleId &&
                lineItem.product_type === 'orthotic' &&
                lineItem.variant_id != nonBundledVariantId
            );
        });

        if (bundledOrthotic) {
            await Shopify.removeItems([bundledOrthotic.key]);
            await Shopify.addToCart([
                {
                    ...bundledOrthotic,
                    id: nonBundledVariantId,
                },
            ]);
        }
    }

    /**
     * products is an array of objects of this type
     * {
     *  id: string;
     *  handle: string;
     *  title: string;
     *  quantity: number;
     *  type: string; (orthotic or footwear)
     *  src: string; (image src)
     *  altText: string; (image alt text)
     *  bundleVariantId: string;
     * }
     */
    static async initBundle({ bundleId, size, gender, products }) {
        bundleId = bundleId || Utils.generateBundleId();
        const status = BUNDLE_STATUS.IN_PROGRESS;

        const bundle = {
            status,
            size,
            gender,
            bundleId,
            productsInBundle: products,
        };
        setCookie(STORAGE_KEYS.bundle, bundle);
        publish(PUB_SUB_EVENTS.bundleStarted);
        return bundle;
    }

    static async cancelBundle() {
        const bundle = BundlesManagerClass.getBundle();
        if (bundle) {
            const cart = await Shopify.getCart();
            const lineItemsToUpdate = cart.items
                .filter((lineItem) => {
                    return lineItem?.properties?.['_bundleId'] === bundle.bundleId;
                })
                .map((lineItem) => {
                    return {
                        id: lineItem.key,
                        properties: {
                            ...lineItem.properties,
                            _bundleId: null,
                        },
                    };
                });

            for (const item of lineItemsToUpdate) {
                await Shopify.updateLineItems(item, { updateCart: true });
            }

            publish(PUB_SUB_EVENTS.bundleCancelled);
            BundlesManagerClass.clearBundleMemory();
        }
    }

    static completeBundle() {
        setCookie(STORAGE_KEYS.bundle, {
            status: this.bundleStatus,
        });
        publish(PUB_SUB_EVENTS.bundleCompleted);
    }

    static getBundle() {
        const bundle = window.localStorage.getItem(STORAGE_KEYS.bundle);
        return bundle ? JSON.parse(bundle) : null;
    }

    static saveBundle(bundle) {
        setCookie(STORAGE_KEYS.bundle, bundle);
    }

    static clearBundleMemory() {
        window.localStorage.removeItem(STORAGE_KEYS.bundle);
    }
}

window.BundlesManager = new BundlesManagerClass();

class MenuDrawer extends HTMLElement {
    constructor() {
        super();

        this.mainDetailsToggle = this.querySelector('details');

        if (navigator.platform === 'iPhone')
            document.documentElement.style.setProperty(
                '--viewport-height',
                `${window.innerHeight}px`
            );

        this.addEventListener('keyup', this.onKeyUp.bind(this));
        this.addEventListener('focusout', this.onFocusOut.bind(this));
        this.bindEvents();
    }

    bindEvents() {
        this.querySelectorAll('summary').forEach((summary) =>
            summary.addEventListener('click', this.onSummaryClick.bind(this))
        );
        this.querySelectorAll('button').forEach((button) =>
            button.addEventListener('click', this.onCloseButtonClick.bind(this))
        );
    }

    onKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;

        const openDetailsElement = event.target.closest('details[open]');
        if (!openDetailsElement) return;

        openDetailsElement === this.mainDetailsToggle
            ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
            : this.closeSubmenu(openDetailsElement);
    }

    onSummaryClick(event) {
        const summaryElement = event.currentTarget;
        const detailsElement = summaryElement.parentNode;
        const parentMenuElement = detailsElement.closest('.has-submenu');
        const isOpen = detailsElement.hasAttribute('open');
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        function addTrapFocus() {
            trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
            summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
        }

        if (detailsElement === this.mainDetailsToggle) {
            if (isOpen) event.preventDefault();
            isOpen
                ? this.closeMenuDrawer(event, summaryElement)
                : this.openMenuDrawer(summaryElement);
        } else {
            setTimeout(() => {
                detailsElement.classList.add('menu-opening');
                summaryElement.setAttribute('aria-expanded', true);
                parentMenuElement && parentMenuElement.classList.add('submenu-open');
                !reducedMotion || reducedMotion.matches
                    ? addTrapFocus()
                    : summaryElement.nextElementSibling.addEventListener(
                          'transitionend',
                          addTrapFocus
                      );
            }, 100);
        }
    }

    openMenuDrawer(summaryElement) {
        setTimeout(() => {
            this.mainDetailsToggle.classList.add('menu-opening');
        });
        summaryElement.setAttribute('aria-expanded', true);
        trapFocus(this.mainDetailsToggle, summaryElement);
        document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }

    closeMenuDrawer(event, elementToFocus = false) {
        if (event === undefined) return;

        this.mainDetailsToggle.classList.remove('menu-opening');
        this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
            details.removeAttribute('open');
            details.classList.remove('menu-opening');
        });
        this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
            submenu.classList.remove('submenu-open');
        });
        document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
        removeTrapFocus(elementToFocus);
        this.closeAnimation(this.mainDetailsToggle);
    }

    onFocusOut(event) {
        setTimeout(() => {
            if (
                this.mainDetailsToggle.hasAttribute('open') &&
                !this.mainDetailsToggle.contains(document.activeElement)
            )
                this.closeMenuDrawer();
        });
    }

    onCloseButtonClick(event) {
        const detailsElement = event.currentTarget.closest('details');
        this.closeSubmenu(detailsElement);
    }

    closeSubmenu(detailsElement) {
        const parentMenuElement = detailsElement.closest('.submenu-open');
        parentMenuElement && parentMenuElement.classList.remove('submenu-open');
        detailsElement.classList.remove('menu-opening');
        detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
        removeTrapFocus(detailsElement.querySelector('summary'));
        this.closeAnimation(detailsElement);
    }

    closeAnimation(detailsElement) {
        let animationStart;

        const handleAnimation = (time) => {
            if (animationStart === undefined) {
                animationStart = time;
            }

            const elapsedTime = time - animationStart;

            if (elapsedTime < 400) {
                window.requestAnimationFrame(handleAnimation);
            } else {
                detailsElement.removeAttribute('open');
                if (detailsElement.closest('details[open]')) {
                    trapFocus(
                        detailsElement.closest('details[open]'),
                        detailsElement.querySelector('summary')
                    );
                }
            }
        };

        window.requestAnimationFrame(handleAnimation);
    }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
    constructor() {
        super();
    }

    openMenuDrawer(summaryElement) {
        this.header = this.header || document.getElementById('shopify-section-header');
        this.borderOffset =
            this.borderOffset ||
            this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom')
                ? 1
                : 0;
        document.documentElement.style.setProperty(
            '--header-bottom-position',
            `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
        );
        this.header.classList.add('menu-open');

        setTimeout(() => {
            this.mainDetailsToggle.classList.add('menu-opening');
        });

        summaryElement.setAttribute('aria-expanded', true);
        trapFocus(this.mainDetailsToggle, summaryElement);
        document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }

    closeMenuDrawer(event, elementToFocus) {
        super.closeMenuDrawer(event, elementToFocus);
        this.header.classList.remove('menu-open');
    }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
    constructor() {
        super();
        this.querySelector('[id^="ModalClose-"]').addEventListener(
            'click',
            this.hide.bind(this, false)
        );
        this.addEventListener('keyup', (event) => {
            if (event.code.toUpperCase() === 'ESCAPE') this.hide();
        });
        if (this.classList.contains('media-modal')) {
            this.addEventListener('pointerup', (event) => {
                if (
                    event.pointerType === 'mouse' &&
                    !event.target.closest('deferred-media, product-model')
                )
                    this.hide();
            });
        } else {
            this.addEventListener('click', (event) => {
                if (event.target === this) this.hide();
            });
        }
    }

    connectedCallback() {
        if (this.moved) return;
        this.moved = true;
        document.body.appendChild(this);
    }

    show(opener) {
        this.openedBy = opener;
        const popup = this.querySelector('.template-popup');
        document.body.classList.add('overflow-hidden');
        this.setAttribute('open', '');
        if (popup) popup.loadContent();
        trapFocus(this, this.querySelector('[role="dialog"]'));
        window.pauseAllMedia();
    }

    hide() {
        document.body.classList.remove('overflow-hidden');
        document.body.dispatchEvent(new CustomEvent('modalClosed'));
        this.removeAttribute('open');
        removeTrapFocus(this.openedBy);
        window.pauseAllMedia();
    }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
    constructor() {
        super();

        const button = this.querySelector('button');

        if (!button) return;
        button.addEventListener('click', () => {
            const modal = document.querySelector(this.getAttribute('data-modal'));
            if (modal) modal.show(button);
        });
    }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
    constructor() {
        super();
        const poster = this.querySelector('[id^="Deferred-Poster-"]');
        if (!poster) return;
        poster.addEventListener('click', this.loadContent.bind(this));
    }

    loadContent(focus = true) {
        window.pauseAllMedia();
        if (!this.getAttribute('loaded')) {
            const content = document.createElement('div');
            content.appendChild(
                this.querySelector('template').content.firstElementChild.cloneNode(true)
            );

            this.setAttribute('loaded', true);
            const deferredElement = this.appendChild(
                content.querySelector('video, model-viewer, iframe')
            );
            if (focus) deferredElement.focus();
        }
    }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
    constructor() {
        super();
        this.slider = this.querySelector('[id^="Slider-"]');
        this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
        this.enableSliderLooping = false;
        this.currentPageElement = this.querySelector('.slider-counter--current');
        this.pageTotalElement = this.querySelector('.slider-counter--total');
        this.prevButton = this.querySelector('button[name="previous"]');
        this.nextButton = this.querySelector('button[name="next"]');

        if (!this.slider || !this.nextButton) return;

        this.initPages();
        const resizeObserver = new ResizeObserver((entries) => this.initPages());
        resizeObserver.observe(this.slider);

        this.slider.addEventListener('scroll', this.update.bind(this));
        this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
        this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    }

    initPages() {
        this.sliderItemsToShow = Array.from(this.sliderItems).filter(
            (element) => element.clientWidth > 0
        );
        if (this.sliderItemsToShow.length < 2) return;
        this.sliderItemOffset =
            this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
        this.slidesPerPage = Math.floor(
            (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
        );
        this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
        this.update();
    }

    resetPages() {
        this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
        this.initPages();
    }

    update() {
        const previousPage = this.currentPage;
        this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

        if (this.currentPageElement && this.pageTotalElement) {
            this.currentPageElement.textContent = this.currentPage;
            this.pageTotalElement.textContent = this.totalPages;
        }

        if (this.currentPage != previousPage) {
            this.dispatchEvent(
                new CustomEvent('slideChanged', {
                    detail: {
                        currentPage: this.currentPage,
                        currentElement: this.sliderItemsToShow[this.currentPage - 1],
                    },
                })
            );
        }

        if (this.enableSliderLooping) return;

        if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
            this.prevButton.setAttribute('disabled', 'disabled');
        } else {
            this.prevButton.removeAttribute('disabled');
        }

        if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
            this.nextButton.setAttribute('disabled', 'disabled');
        } else {
            this.nextButton.removeAttribute('disabled');
        }
    }

    isSlideVisible(element, offset = 0) {
        const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
        return (
            element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
            element.offsetLeft >= this.slider.scrollLeft
        );
    }

    onButtonClick(event) {
        event.preventDefault();
        const step = event.currentTarget.dataset.step || 1;
        this.slideScrollPosition =
            event.currentTarget.name === 'next'
                ? this.slider.scrollLeft + step * this.sliderItemOffset
                : this.slider.scrollLeft - step * this.sliderItemOffset;
        this.slider.scrollTo({
            left: this.slideScrollPosition,
        });
    }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
    constructor() {
        super();
        this.sliderControlWrapper = this.querySelector('.slider-buttons');
        this.enableSliderLooping = true;

        if (!this.sliderControlWrapper) return;

        this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
        if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

        this.sliderControlLinksArray = Array.from(
            this.sliderControlWrapper.querySelectorAll('.slider-counter__link')
        );
        this.sliderControlLinksArray.forEach((link) =>
            link.addEventListener('click', this.linkToSlide.bind(this))
        );
        this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
        this.setSlideVisibility();

        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
    }

    setAutoPlay() {
        this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
        this.autoplaySpeed = this.slider.dataset.speed * 1000;

        this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
        this.addEventListener('mouseover', this.focusInHandling.bind(this));
        this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
        this.addEventListener('focusin', this.focusInHandling.bind(this));
        this.addEventListener('focusout', this.focusOutHandling.bind(this));

        this.play();
        this.autoplayButtonIsSetToPlay = true;
    }

    onButtonClick(event) {
        super.onButtonClick(event);
        const isFirstSlide = this.currentPage === 1;
        const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

        if (!isFirstSlide && !isLastSlide) return;

        if (isFirstSlide && event.currentTarget.name === 'previous') {
            this.slideScrollPosition =
                this.slider.scrollLeft +
                this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
        } else if (isLastSlide && event.currentTarget.name === 'next') {
            this.slideScrollPosition = 0;
        }
        this.slider.scrollTo({
            left: this.slideScrollPosition,
        });
    }

    update() {
        super.update();
        this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
        this.prevButton.removeAttribute('disabled');

        if (!this.sliderControlButtons.length) return;

        this.sliderControlButtons.forEach((link) => {
            link.classList.remove('slider-counter__link--active');
            link.removeAttribute('aria-current');
        });
        this.sliderControlButtons[this.currentPage - 1].classList.add(
            'slider-counter__link--active'
        );
        this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
    }

    autoPlayToggle() {
        this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
        this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
        this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
    }

    focusOutHandling(event) {
        const focusedOnAutoplayButton =
            event.target === this.sliderAutoplayButton ||
            this.sliderAutoplayButton.contains(event.target);
        if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
        this.play();
    }

    focusInHandling(event) {
        const focusedOnAutoplayButton =
            event.target === this.sliderAutoplayButton ||
            this.sliderAutoplayButton.contains(event.target);
        if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
            this.play();
        } else if (this.autoplayButtonIsSetToPlay) {
            this.pause();
        }
    }

    play() {
        this.slider.setAttribute('aria-live', 'off');
        clearInterval(this.autoplay);
        this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
    }

    pause() {
        this.slider.setAttribute('aria-live', 'polite');
        clearInterval(this.autoplay);
    }

    togglePlayButtonState(pauseAutoplay) {
        if (pauseAutoplay) {
            this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
            this.sliderAutoplayButton.setAttribute(
                'aria-label',
                window.accessibilityStrings.playSlideshow
            );
        } else {
            this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
            this.sliderAutoplayButton.setAttribute(
                'aria-label',
                window.accessibilityStrings.pauseSlideshow
            );
        }
    }

    autoRotateSlides() {
        const slideScrollPosition =
            this.currentPage === this.sliderItems.length
                ? 0
                : this.slider.scrollLeft +
                  this.slider.querySelector('.slideshow__slide').clientWidth;
        this.slider.scrollTo({
            left: slideScrollPosition,
        });
    }

    setSlideVisibility() {
        this.sliderItemsToShow.forEach((item, index) => {
            const button = item.querySelector('a');
            if (index === this.currentPage - 1) {
                if (button) button.removeAttribute('tabindex');
                item.setAttribute('aria-hidden', 'false');
                item.removeAttribute('tabindex');
            } else {
                if (button) button.setAttribute('tabindex', '-1');
                item.setAttribute('aria-hidden', 'true');
                item.setAttribute('tabindex', '-1');
            }
        });
    }

    linkToSlide(event) {
        event.preventDefault();
        const slideScrollPosition =
            this.slider.scrollLeft +
            this.sliderFirstItemNode.clientWidth *
                (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
        this.slider.scrollTo({
            left: slideScrollPosition,
        });
    }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('change', this.onVariantChange);
    }

    onVariantChange() {
        this.updateOptions();
        this.updateMasterId();
        this.toggleAddButton(true, '', false);
        this.updatePickupAvailability();
        this.removeErrorMessage();

        if (!this.currentVariant) {
            this.toggleAddButton(true, '', true);
            this.setUnavailable();
        } else {
            this.updateMedia();
            this.updateURL();
            this.updateVariantInput();
            this.renderProductInfo();
            this.updateShareUrl();
        }
    }

    updateOptions() {
        this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    }

    updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
            return !variant.options
                .map((option, index) => {
                    return this.options[index] === option;
                })
                .includes(false);
        });
    }

    updateMedia() {
        if (!this.currentVariant) return;
        if (!this.currentVariant.featured_media) return;

        const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
        mediaGallery.setActiveMedia(
            `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
            true
        );

        const modalContent = document.querySelector(
            `#ProductModal-${this.dataset.section} .product-media-modal__content`
        );
        if (!modalContent) return;
        const newMediaModal = modalContent.querySelector(
            `[data-media-id="${this.currentVariant.featured_media.id}"]`
        );
        modalContent.prepend(newMediaModal);
    }

    updateURL() {
        if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
        window.history.replaceState(
            {},
            '',
            `${this.dataset.url}?variant=${this.currentVariant.id}`
        );
    }

    updateShareUrl() {
        const shareButton = document.getElementById(`Share-${this.dataset.section}`);
        if (!shareButton || !shareButton.updateUrl) return;
        shareButton.updateUrl(
            `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
        );
    }

    updateVariantInput() {
        const productForms = document.querySelectorAll(
            `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        );
        productForms.forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            input.value = this.currentVariant.id;
            input.dispatchEvent(new Event('change', { bubbles: true }));
        });
    }

    updatePickupAvailability() {
        const pickUpAvailability = document.querySelector('pickup-availability');
        if (!pickUpAvailability) return;

        if (this.currentVariant && this.currentVariant.available) {
            pickUpAvailability.fetchAvailability(this.currentVariant.id);
        } else {
            pickUpAvailability.removeAttribute('available');
            pickUpAvailability.innerHTML = '';
        }
    }

    removeErrorMessage() {
        const section = this.closest('section');
        if (!section) return;

        const productForm = section.querySelector('product-form');
        if (productForm) productForm.handleErrorMessage();
    }

    renderProductInfo() {

        var _product_form = document.querySelector('product-form');
        if(_product_form){
            _product_form.dataset.variantId = this.currentVariant.id;
        }

        fetch(
            `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${
                this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
            }`
        )
            .then((response) => response.text())
            .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, 'text/html');
                const destination = document.getElementById(`price-${this.dataset.section}`);
                const source = html.getElementById(
                    `price-${
                        this.dataset.originalSection
                            ? this.dataset.originalSection
                            : this.dataset.section
                    }`
                );
                if (source && destination) destination.innerHTML = source.innerHTML;
                const price = document.getElementById(`price-${this.dataset.section}`);

                if (price) price.classList.remove('visibility-hidden');
                this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
            });
    }

    toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = document.getElementById(`product-form-${this.dataset.section}`);
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span');
        if (!addButton) return;

        if (disable) {
            addButton.setAttribute('disabled', 'disabled');
            if (text) addButtonText.textContent = text;
        } else {
            addButton.removeAttribute('disabled');
            addButtonText.textContent = window.variantStrings.addToCart;
        }

        if (!modifyClass) return;
    }

    setUnavailable() {
        const button = document.getElementById(`product-form-${this.dataset.section}`);
        const addButton = button.querySelector('[name="add"]');
        const addButtonText = button.querySelector('[name="add"] > span');
        const price = document.getElementById(`price-${this.dataset.section}`);
        if (!addButton) return;
        addButtonText.textContent = window.variantStrings.unavailable;
        if (price) price.classList.add('visibility-hidden');
    }

    getVariantData() {
        this.variantData =
            this.variantData ||
            JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
    constructor() {
        super();
        this.sizes = this.querySelector('[data-option-name="Size"]');
        if(this.sizes) this.variantSortSize();
    }

     variantSortSize() {
        document.querySelectorAll('[data-option-name="Size"]').forEach(fieldset => {
        const items = [];

        fieldset.querySelectorAll('input[type="radio"]').forEach(input => {
            const label = fieldset.querySelector(`label[for="${input.id}"]`);

            items.push({
            value: parseFloat(input.value),
            input,
            label
            });
        });

        items
            .sort((a, b) => a.value - b.value)
            .forEach(item => {
            fieldset.appendChild(item.input);
            fieldset.appendChild(item.label);
            });
        });
    }

    updateOptions() {
        const fieldsets = Array.from(this.querySelectorAll('fieldset'));
        this.options = fieldsets.map((fieldset) => {
            return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked)
                .value;
        });
    }
}

customElements.define('variant-radios', VariantRadios);

//bundle-flag element
class bundleFlag extends HTMLElement {
    constructor() {
        super();
        this.viewToggle = this.querySelector('.bundle-flag__toggle');
        this.titleContainer = this.querySelector('.product-name-ui');
        this.productNeededContainer = this.querySelector('.product-needed-ui');
        this.cancelBundleButton = this.querySelector('[name=cancel-bundle]');

        subscribe(PUB_SUB_EVENTS.bundleStarted, this.onBundleStarted.bind(this));
        subscribe(PUB_SUB_EVENTS.bundleCancelled, this.close.bind(this));
        subscribe(PUB_SUB_EVENTS.bundleCompleted, this.close.bind(this));
        const bundledProductData = BundlesManagerClass.getBundle();
        if (bundledProductData?.status === 'in-progress') {
            this.updateProductNeededText();
            this.showBundle();
            this.updateCollapsedStatus();
        }

        this.bindEvents();
    }

    onBundleStarted() {
        this.updateProductNeededText();
        this.showBundle();
    }

    updateProductNeededText() {
        const bundleData = BundlesManagerClass.getBundle();
        if (!bundleData) return;
        const productTypeInBundle = bundleData.productsInBundle[0].type;
        const neededType = productTypeInBundle === 'footwear' ? 'orthotic' : 'shoe';
        this.productNeededContainer.textContent = neededType;
    }

    updateBundleTitle() {
        const bundledProduct = BundlesManagerClass.getBundle();
        if (bundledProduct?.productsInBundle) {
            const bundledProductTitle = bundledProduct.productsInBundle[0].title;
            this.titleContainer.textContent = bundledProductTitle;
        }
    }

    updateCollapsedStatus() {
        const collapsedStatus = getCookie(STORAGE_KEYS.flagCollapsedStatus);
        if (collapsedStatus === 'closed') {
            this.classList.remove('bundle-flag--open');
            this.classList.add('bundle-flag--closed');
        } else {
            this.classList.add('bundle-flag--open');
            this.classList.remove('bundle-flag--closed');
        }
    }

    bindEvents() {
        this.viewToggle.addEventListener('click', this.onToggleClick.bind(this));
        this.cancelBundleButton.addEventListener('click', this.onCancelClick.bind(this));
    }

    // handles collapsing and expanding the bundle flag
    onToggleClick() {
        if (this.classList.contains('bundle-flag--open')) {
            this.classList.remove('bundle-flag--open');
            this.classList.add('bundle-flag--closed');
            setCookie(STORAGE_KEYS.flagCollapsedStatus, 'closed');
        } else {
            this.classList.add('bundle-flag--open');
            this.classList.remove('bundle-flag--closed');
            setCookie(STORAGE_KEYS.flagCollapsedStatus, 'open');
        }
    }

    async onCancelClick() {
        BundlesManagerClass.cancelBundle();
    }

    showBundle() {
        this.updateBundleTitle();
        this.open();
    }

    open() {
        this.classList.add('active-bundle-ui--visible');
    }

    close() {
        this.classList.remove('active-bundle-ui--visible');
    }
}

customElements.define('bundle-flag', bundleFlag);

// get top-level items from a dropdown menu
var mainMenuItems = document.querySelectorAll('.cmp-header__link--level-1');

// set actions for mouse over and mouse leave
var mainMenuHoverIntent = new SV.HoverIntent(mainMenuItems, {
    // required parameters
    onEnter: function (targetItem) {
        targetItem.classList.add('active');
        if (targetItem.classList.contains('cmp-header__link--has-submenu')) document.body.classList.add('submenu-open');
    },
    onExit: function (targetItem) {
        targetItem.classList.remove('active');
        if (targetItem.classList.contains('cmp-header__link--has-submenu')) document.body.classList.remove('submenu-open');
    },

    // default options
    exitDelay: 200,
    interval: 100,
    sensitivity: 5,
});

window.addEventListener('DOMContentLoaded', () => {
    const tabs = document.querySelectorAll('[role="tab"]');

    // Add a click event handler to each tab
    tabs.forEach((tab) => {
        tab.addEventListener('click', changeTabs);
    });
});

function changeTabs(e) {
    const target = e.target;
    const parent = target.parentNode;
    const grandparent = parent.parentNode;

    // Remove all current selected tabs
    parent
        .querySelectorAll('[aria-selected="true"]')
        .forEach((t) => t.setAttribute('aria-selected', false));

    // Set this tab as selected
    target.setAttribute('aria-selected', true);

    // Hide all tab panels
    grandparent
        .querySelectorAll('[role="tabpanel"]')
        .forEach((p) => p.setAttribute('hidden', true));

    // Show the selected panel
    grandparent.parentNode
        .querySelector(`#${target.getAttribute('aria-controls')}`)
        .removeAttribute('hidden');
}

window.addEventListener('DOMContentLoaded', function () {
    const dialogs = document.querySelectorAll('.cmp-dialog');
    dialogs.forEach((dialog) => {
        const closeButtons = dialog.querySelectorAll('.cmp-dialog__close');
        closeButtons.forEach((closeButton) => {
            closeButton.addEventListener('click', () => dialog.close());
        });
    });
});

class TypeformModal extends HTMLElement {
    constructor() {
        super();
        this.dialog = this.querySelector('dialog');
        this.typeformWidget = this.querySelector('[name="typeform-widget"]');
        this.closeDelay = Number.parseInt(this.dataset.closeDelay) || 0;

        document.addEventListener('typeformSubmit', (e) => {
            const { formId, responseId } = e.detail;
            this.submitHandler({ formId, responseId });
        });
        if (this.typeformWidget) {
            this.typeformWidget.setAttribute('data-tf-on-submit', `handleTypeformModalSubmit`);
        }
    }

    submitHandler({ formId, responseId }) {
        const typeformId = this.typeformWidget?.getAttribute('data-tf-widget');
        if (typeformId == formId && this.dialog.open) {
            // setTimeout(() => {
            //     this.dialog.close();
            // }, this.closeDelay);

            this.dispatchEvent(
                new CustomEvent('submit', {
                    bubbles: true,
                    detail: {
                        formId,
                        responseId,
                    },
                })
            );
        }
    }
}

handleTypeformModalSubmit = ({ formId, responseId }) => {
    document.dispatchEvent(
        new CustomEvent('typeformSubmit', {
            bubbles: true,
            detail: {
                formId,
                responseId,
            },
        })
    );
};

// @TODO separate these components into different files
class SizeSelector extends HTMLElement {
    shoeSizes = {
        // @TODO get real sizes for youth and unisex
        "Men's": [
            2, 2.5, 3, 3.5, 4, 4.5, 5, 5.5, 6, 6.5, 7, 7.5, 8, 8.5, 9, 9.5, 10, 10.5, 11, 11.5, 12,
            12.5, 13, 13.5, 14,
        ],
        "Women's": [
            4, 4.5, 5, 5.5, 6, 6.5, 7, 7.5, 8, 8.5, 9, 9.5, 10, 10.5, 11, 11.5, 12, 12.5, 13, 13.5,
            14,
        ],
        "Youth": [1, 2, 3, 4, 4.5, 5, 5.5, 6, 6.5, 7],
    };

    constructor() {
        super();
        this.form = this.querySelector('form');
        this.genderSelect = this.querySelector('select[name=gender]');
        this.sizeSelect = this.querySelector('select[name=size]');
        this.submitButton = this.querySelector('button[type=submit]');
        this.sizePreferencesSet = this.getSavedPreferences();
        // const savedPreferences = this.getSavedPreferences();
        // if (savedPreferences) {
        //     this.genderSelect.value = savedPreferences.gender;
        //     this.updateSizeOptions(savedPreferences.gender);
        //     this.sizeSelect.value = savedPreferences.size;
        //     this.sizeSelect.disabled = false;
        //     this.checkEnableSubmit();
        // }
    }

    connectedCallback() {
        this.genderSelect.addEventListener('change', (e) => {
            this.updateSizeOptions(e.target.value);
            if (e.target.value) {
                this.sizeSelect.disabled = false;
            }

            this.checkEnableSubmit();
        });
        this.sizeSelect.addEventListener('change', () => this.checkEnableSubmit());
        this.form.addEventListener('submit', (e) => {
            e.preventDefault();
            e.stopPropagation();
            const event = new CustomEvent('submit', {
                bubbles: true,
                detail: {
                    size: this.sizeSelect.value,
                    gender: this.genderSelect.value,
                },
            });

            this.dispatchEvent(event);
            this.setSavedPreferences();
        });
    }

    updateSizeOptions(gender) {
        const options = this.shoeSizes[gender];
        const optionElements = options.map((option) => {
            const optionElement = document.createElement('option');
            optionElement.textContent = option;
            return optionElement;
        });
        this.sizeSelect.querySelectorAll('option:not(:first-child)').forEach((option) => {
            option.remove();
        });
        optionElements.forEach((option) => {
            this.sizeSelect.appendChild(option);
        });
    }

    checkEnableSubmit() {
        if (this.genderSelect.value && this.sizeSelect.value) {
            this.submitButton.disabled = false;
        } else {
            this.submitButton.disabled = true;
        }
    }

    getSavedPreferences() {
        // const value = getCookie(STORAGE_KEYS.sizePreferences);
        // return value ? JSON.parse(value) : null;
        const value = getCookie(STORAGE_KEYS.sizePreferencesSet);
        return value ? JSON.parse(value) : false;
    }

    setSavedPreferences() {
        // setCookie(STORAGE_KEYS.sizePreferences, {
        //     gender: this.genderSelect.value,
        //     size: this.sizeSelect.value,
        // });
        setCookie(STORAGE_KEYS.sizePreferencesSet, true);
    }
}

customElements.define('size-selector', SizeSelector);

window.Utils = {
    wait: (n) => {
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve();
            }, n);
        });
    },
    generateBundleId: () => Math.random().toString(36),
};

customElements.define('typeform-modal', TypeformModal);

class BundledProducts extends HTMLElement {
    constructor() {
        super();
        this.bundleId = this.dataset.bundleId;
        this.removeBundleButton = this.querySelector('.btn-remove-bundle');
        this.removeBundleButton.addEventListener('click', this.onBundleRemove.bind(this));
        this.cart = document.querySelector('cart-drawer');
        this.nonBundledOrthoticId = this.dataset.nonBundledOrthoticId;
        this.removeIndividualItemButtons = this.querySelectorAll('.cart-bundle-row__remove-btn');
        this.bindIndividualItemRemoveEvents();
    }

    async onBundleRemove(e) {
        e.preventDefault();
        const cart = await Shopify.getCart();
        const lineItemsToRemove = cart.items.filter((lineItem) => {
            return lineItem?.properties?.['_bundleId'] === this.bundleId;
        });

        await Shopify.removeItems(lineItemsToRemove.map((lineItem) => lineItem.key));
        await this.cart.refreshCart();
        publish(PUB_SUB_EVENTS.bundleCancelled);
    }

    bindIndividualItemRemoveEvents() {
        this.removeIndividualItemButtons.forEach((button) => {
            button.addEventListener('click', async (e) => {
                e.preventDefault();
                e.stopPropagation();
                const lineItemKey = button.dataset.key;
                await Shopify.removeItems([lineItemKey]);
                const result = await BundlesManagerClass.demoteBundle(
                    this.bundleId,
                    this.nonBundledOrthoticId
                );
                if (!result) {
                    await this.cart.refreshCart();
                }
            });
        });
    }
}

customElements.define('bundled-products', BundledProducts);

class SuccessBundleDialog extends HTMLElement {
    constructor() {
        super();

        this.dialog = this.querySelector('dialog');
        const bundle = this.getActiveBundle();
        if (bundle) {
            const firstImageBundleElement = this.querySelector('.first-bundle-image');
            const firstImageBundle = bundle.productsInBundle[0].src;
            firstImageBundleElement.src = firstImageBundle;
            firstImageBundleElement.setAttribute('alt', bundle.productsInBundle[0].altText);
        }
    }

    getActiveBundle() {
        const bundle = getCookie(STORAGE_KEYS.bundle);
        return bundle ? JSON.parse(bundle) : null;
    }
}

customElements.define('success-bundle-dialog', SuccessBundleDialog);

class UpsellDialog extends HTMLElement {
    constructor() {
        super();
        this.orthoticsInfoContainer = this.querySelector('.orthotics-upsell-container');
        if (this.orthoticsInfoContainer) {
            // @TODO: can be improved to fetch when modal is opened. Will need to show a loader in the meantime
            this.fetchOrthoticsContainerData();
        }
    }

    async fetchOrthoticsContainerData() {
        const section = await Shopify.renderSection({
            url: '/collections/custom-orthotics',
            section_id: 'multi-cta-group',
            selector: '.cmp-multi-cta-group__list',
        });

        this.orthoticsInfoContainer.appendChild(section);
    }
}

customElements.define('upsell-dialog', UpsellDialog);

var footer_title = document.querySelectorAll('.cmp-footer_menu-title');
if(footer_title) {
    footer_title.forEach((item) => {
        item.addEventListener('click', (event) => {
            item.classList.toggle('open');
        });
    });
}

document.addEventListener('DOMContentLoaded', () => {
  const item_sort = document.querySelectorAll('.item-sort-custom');
  const sort_by = document.querySelector('[name=sort_by]');
  const sort_form = sort_by ? sort_by.closest('form') : null;

  if (!item_sort || !sort_by || !sort_form) return;

  item_sort.forEach((item) => {
    item.addEventListener('click', () => {
      item_sort.forEach(el => el.classList.remove('selected'));
      item.classList.add('selected');

      const newValue = item.getAttribute('data-value');
      if (!newValue) return;
      sort_by.value = newValue;
      sort_form.submit();
      document.body.classList.add('sorting-loading');
    });
  });

  document.addEventListener('shopify:section:load', (e) => {
    document.body.classList.remove('sorting-loading');
  });
});
